export const getAccessedAt = (): number => Date.now();
